import Vue from 'vue'
import { MARK_DIRTY, MARK_CLEAN } from './mutationsTypes'

// Editors that hold input the user has not saved yet, by id. While any is
// set, the app does not reload itself for an update (src/utils/appUpdate.js)
// and closing the tab asks first.
const state = {
  dirtyIds: {}
}

const mutations = {
  [MARK_DIRTY] (state, id) {
    Vue.set(state.dirtyIds, id, true)
  },
  [MARK_CLEAN] (state, id) {
    Vue.delete(state.dirtyIds, id)
  }
}

const getters = {
  hasUnsavedChanges: state => Object.keys(state.dirtyIds).length > 0
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
